import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from '../../../context/AppContext.js';
import LoadingScreen from "../../../componente/aguarde/index.jsx";
import Impressora from "../../../assets/Impressora.png";
import ImgXLS from "../../../assets/XLS.png";
import * as XLSX from 'xlsx';

function RelSaldoPonto() {
    const [lista, setlista] = useState([]);
    const [loading, setLoading] = useState(false);

    const { selectedCompany, accessKey } = useAppContext(); 

    // Função para calcular o primeiro dia do mês
    const getFirstDayOfMonth = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    function ListarPonto() {
        api
            .get("/v1/relatorio/saldoponto", {
                params: {
                    codempresa: selectedCompany,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarPonto();
        },
        [selectedCompany, dt1, dt2]
    );

    const imprimir = async () => {
        setLoading(true);

        try {
            const response = await api.get(`/v1/impressoes/relatorio/saldoponto`, {
                responseType: "arraybuffer",
                params: {
                    codempresa: selectedCompany,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    };

    const exportToExcel = () => {
        // Cria uma nova planilha a partir dos dados da tabela
        const worksheet = XLSX.utils.json_to_sheet(lista);

        // Cria uma nova pasta de trabalho e adiciona a planilha
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Exporta o arquivo Excel com o nome especificado
        XLSX.writeFile(workbook, `relsaldoponto.xlsx`);
    };

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div className="row">
                        <h1 className="ms-4">Relatório de Saldo de Ponto</h1>
                        <p className="ms-4">Relatório dos saldos dos pontos que foi registrado pelos profissionais</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="d-flex justify-content-between">
                            <div className="row">
                                <div className="col-6">
                                    <label htmlFor="dt1" className="form-label">
                                        De...
                                    </label>
                                    <input
                                        type="date"
                                        id="dt1"
                                        className="form-control"
                                        placeholder="Dt. Lançamento"
                                        value={dt1}
                                        onChange={(e) => setdt1(e.target.value)}
                                    />
                                </div>

                                <div className="col-6">
                                    <label htmlFor="dt2" className="form-label">
                                        Para...
                                    </label>
                                    <input
                                        type="date"
                                        id="dt2"
                                        className="form-control"
                                        placeholder="Dt. Lançamento"
                                        value={dt2}
                                        onChange={(e) => setdt2(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="col-sm-6 d-flex justify-content-end">
                                <div className="col-sm-1 d-flex justify-content-center">
                                    <button className="btn" onClick={exportToExcel}>
                                        <img src={ImgXLS} alt="XLS" />
                                        <label>Excel</label>
                                    </button>
                                    {loading && <LoadingScreen />}
                                </div>

                                <div className="col-sm-1 d-flex justify-content-center">
                                    <button className="btn" onClick={imprimir}>
                                        <img src={Impressora} alt="Imprimir" />
                                        <label>Imprimir</label>
                                    </button>
                                    {loading && <LoadingScreen />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Saldo de Horas Trabalhadas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item, index) {
                                    return (
                                        <tr key={index}>
                                            <th>{item.nome}</th>
                                            <th>{item.totalhorastrabalhadas}</th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={2}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RelSaldoPonto;
